// import '../css/style.scss'
import { ua } from './modules/ua'
import lottie from 'lottie-web'
import { timetableInit } from './modules/timetable'
import { realTimeTable } from './modules/realtime'
import inView from 'in-view'
import Swiper from 'swiper/bundle'

const klass = {
  active: 'is-active',
  fixed: 'is-fixed',
  view: 'is-view',
  selected: 'is-selected',
  hidden: 'is-hidden',
  eventNone: 'is-eventNone',
  landscape: 'is-landscape',
  current: 'is-current',
  large: 'is-large',
  nav: 'view-nav',
}

class App {
  constructor() {
    this.body = document.querySelector('body')
    this.init()
  }

  init() {
    this.initPages()
  }

  initPages() {
    // 全ページ共通適用
    this.body.classList.add(`is-${ua.browser()}`)
    this.body.classList.add(`is-${ua.os()}`)

    window.addEventListener('load', () => {
      setTimeout(() => {
        this.body.classList.add(`is-loaded`)
      }, 1000)
    })

    timetableInit()

    // ナビゲーション開閉
    document.querySelector('.nav-trigger').addEventListener('click', () => {
      document.querySelector('body').classList.toggle(klass.nav)
    })

    // ナビゲーションを押下時に閉じる
    Array.from(document.querySelectorAll('.header-nav a')).forEach((trigger) => {
      trigger.addEventListener('click', () => {
        document.querySelector('body').classList.toggle(klass.nav)
      })
    })

    inView('.inview').on('enter', (el) => {
      el.classList.add('is-view')
    })
    inView.offset(100)

    if (this.body.classList.contains('page-index')) {
      window.addEventListener('scroll', () => {
        if (window.scrollY > 50) {
          this.body.classList.add('is-scrolled')
        } else {
          this.body.classList.remove('is-scrolled')
        }
      })
    }

    const guideNav = document.querySelector('.guideNav')
    if (guideNav) {
      guideNav.addEventListener('click', () => {
        this.body.classList.toggle('guide-open')
      })
    }

    if (document.querySelector('#timeLine')) {
      realTimeTable()
    }

    if (document.querySelector('.recap-movie-slide')) {
      Array.from(document.querySelectorAll('.recap-movie-slide')).forEach((slider) => {
        const prevEl = slider.querySelector('.recap-movie-slide-button--prev')
        const nextEl = slider.querySelector('.recap-movie-slide-button--next')

        const swiper = new Swiper(slider, {
          slidesPerView: 'auto',
          spaceBetween: 24,
          centeredSlides: true,
          loop: false,
          watchOverflow: true,
          observer: true,
          observeParents: true,
        })

        if (prevEl && nextEl) {
          prevEl.addEventListener('click', () => {
            if (swiper.isBeginning) {
              swiper.slideTo(swiper.slides.length - 1)
              return
            }
            swiper.slidePrev()
          })

          nextEl.addEventListener('click', () => {
            if (swiper.isEnd) {
              swiper.slideTo(0)
              return
            }
            swiper.slideNext()
          })
        }
      })
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.sc22 = new App()
})
